import { gql } from '@apollo/client';
import { toast } from 'react-semantic-toasts';
import { captureException } from '@playbookux/playbook-web-core';

import client from '../../../../../core/services/graphql';

export const deleteProjectMutation = async (projectId) => {
  const query = gql`
    mutation DeleteProjectMutation($projectId: ID!) {
      deleteProject(projectId: $projectId) {
        project {
          id
          name
        }
      }
    }
  `;

  const { data, errors } = await client.getClient().mutate({
    mutation: query,
    variables: { projectId },
  });

  if (!errors) {
    const projectName = data.deleteProject.project.name.length > 25
      ? `${data.deleteProject.project.name.substring(0, 25)}...` : data.deleteProject.project.name;
    toast({
      description: `${projectName} has been deleted`,
      time: 5000,
    });
  }

  try {
    client.getClient().cache.evict(({ id: `Project:${projectId}` }));
  } catch (e) {
    captureException('DELETE_PROJECT_EVICTION_FAILED', e);
  }

  return data;
};

export const updateCompanyMutation = async (companyId, attributes) => {
  const mutation = gql`
    mutation UpdateCompanyMutation($companyId: ID!, $attributes: CompanyAttributes!) {
      updateCompanyMutation(companyId: $companyId, attributes: $attributes) {
        company {
          id
          name
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation,
    variables: { companyId, attributes },
  });

  return data;
};

export const updateProjectShareLink = async (id, sharePassword, shareEnabled) => {
  const mutation = gql`
    mutation UpdateProjectShareLink($id: ID!, $sharePassword: String!, $shareEnabled: Boolean!) {
      updateProjectShareLink(id: $id, sharePassword: $sharePassword, shareEnabled: $shareEnabled) {
        project {
          id
          name
          shareEnabled
          sharePassword
        }
      }
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation,
    variables: { id, sharePassword, shareEnabled },
  });

  return data;
};

export const moveProject = async (projectId, targetCompanyId, folderId) => {
  const mutation = gql`
    mutation MoveProject($projectId: ID!, $targetCompanyId: ID!, $folderId: ID!) { 
      moveProject(projectId: $projectId, targetCompanyId: $targetCompanyId, folderId: $folderId) {
        project { 
          id 
          hasHighlightReelDependency
          company {
            id
          }
        } 
      } 
    }
  `;

  const { data } = await client.getClient().mutate({
    mutation,
    variables: { projectId, targetCompanyId, folderId },
  });

  return data;
};

export const getProjectDependency = async (id) => {
  const query = gql`
    query Project($id: ID!) {
      project(id: $id) {
        id
        hasHighlightReelDependency
        hasTagHighlightDependency
      }
    }
  `;

  const { data } = await client.getClient().query({
    query,
    variables: { id },
  });

  return data;
};
